export default {
  "create": "Create",
  "save": "Save",
  "saveAndNew": "Save & New",
  "discard": "Discard",
  "additionalInfo": "Additional info",
  "loading": "Loading...",
};
